var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 702,
    viewBox: "0 0 502 702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.608 1.04775H138.608C136.969 1.02776 135.343 1.35108 133.837 1.99692C132.33 2.64276 130.974 3.59682 129.858 4.79775L4.8583 129.798C3.65737 130.914 2.7033 132.269 2.05746 133.776C1.41163 135.283 1.08831 136.908 1.10829 138.548V638.548C1.10829 655.124 7.6931 671.021 19.4141 682.742C31.1351 694.463 47.0323 701.048 63.6083 701.048H438.608C455.184 701.048 471.081 694.463 482.802 682.742C494.523 671.021 501.108 655.124 501.108 638.548V63.5477C501.108 46.9717 494.523 31.0746 482.802 19.3536C471.081 7.63255 455.184 1.04775 438.608 1.04775Z",
    fill: "url(#paint0_linear_2267_388)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.359 1.04767C141.106 0.02656 138.588 -0.257327 136.164 0.236459C133.74 0.730245 131.533 1.97651 129.859 3.79766L4.8589 128.798C2.64467 130.401 1.05877 132.726 0.374284 135.373C-0.310196 138.019 -0.0504147 140.822 1.1089 143.298C2.10581 145.745 3.85262 147.813 6.09846 149.206C8.34431 150.598 10.9737 151.243 13.6089 151.048H88.6089C96.8165 151.048 104.944 149.431 112.527 146.29C120.109 143.149 126.999 138.546 132.803 132.742C138.607 126.938 143.21 120.048 146.351 112.465C149.492 104.883 151.109 96.7553 151.109 88.5477V13.5477C151.304 10.9124 150.659 8.28308 149.267 6.03723C147.874 3.79139 145.806 2.04458 143.359 1.04767Z",
    fill: "url(#paint1_linear_2267_388)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2267_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.109 417.381C287.942 417.381 317.776 387.548 317.776 350.715V259.048C317.776 222.215 287.942 192.381 251.109 192.381C214.276 192.381 184.442 222.215 184.442 259.048V350.715C184.442 387.548 214.276 417.381 251.109 417.381Z",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.609 319.881V348.215C123.609 418.548 180.776 475.715 251.109 475.715C321.443 475.715 378.609 418.548 378.609 348.215V319.881",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.942 266.214C242.942 260.714 259.276 260.714 274.276 266.214",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.776 301.548C246.61 299.215 255.776 299.215 264.61 301.548",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.109 475.714V525.714",
    stroke: "white",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_388",
    x1: 17.3583,
    y1: 117.298,
    x2: 532.858,
    y2: 632.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F7A129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4971C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2267_388",
    x1: 1.1089,
    y1: 76.0477,
    x2: 151.109,
    y2: 76.0477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F7A129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4971C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2267_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "white",
    transform: "translate(59.1094 159.048)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.3196d073813237145e91e25259d2d8c9.svg";
export { ForwardRef as ReactComponent };